jQuery(function ($) {

});